export { default as ConfirmSignUp } from './confirm-sign-up';
